// src/components/ContactsPanel.js
import './ContactsPanel.css'

const ZANGI_LINK = process.env.REACT_APP_ZANGI_LINK || 'https://services.zangi.com/dl/conversation/1021528391'
const PHONE      = process.env.REACT_APP_PRIVATE_NUMBER || '+17405610387'
const INSTAGRAM  = process.env.REACT_APP_INSTAGRAM || 'https://www.instagram.com/realskybri'
const TIKTOK     = process.env.REACT_APP_TIKTOK    || 'https://www.tiktok.com/@skybribaby'
const TWITTER    = process.env.REACT_APP_TWITTER   || 'https://x.com/skybri_'

export default function ContactsPanel({ tier }) {
  const rank = tier === 'platinum' ? 3 : tier === 'premium' ? 2 : 1

  const groups = [
    {
      category: 'Public Platforms',
      items: [
        { label: 'Instagram', value: '@realskybri',  link: INSTAGRAM,            minRank: 1 },
        { label: 'TikTok',    value: '@skybribaby',  link: TIKTOK,               minRank: 1 },
        { label: 'X',         value: '@skybri_',     link: TWITTER,              minRank: 1 },
      ]
    },
    {
      category: 'Private Contact',
      items: [
        { label: 'Zangi',          value: 'Sky Bri on Zangi',  link: ZANGI_LINK,         minRank: 2, hint: 'Tap to open Zangi chat' },
        { label: 'Private Number', value: PHONE,               link: `sms:${PHONE}`,     minRank: 2, hint: 'Tap to text directly' },
      ]
    }
  ]

  return (
    <div className="contacts-panel">
      <div className="contacts-panel__header">
        <h2 className="contacts-panel__title">Sky Bri's Contacts</h2>
        <p className="contacts-panel__sub">
          {rank === 1
            ? 'Private contacts are visible but only accessible from Premium tier upward.'
            : rank === 2
            ? 'Your Premium card unlocks Zangi and private number access.'
            : 'Full contact access — you are in the Intimate Circle.'}
        </p>
      </div>

      {groups.map(group => (
        <div key={group.category} className="contacts-group">
          <div className="contacts-group__label">{group.category}</div>
          <div className="contacts-group__items">
            {group.items.map(c => {
              const unlocked = rank >= c.minRank
              return (
                <div key={c.label} className={`contact-row ${unlocked ? 'contact-row--unlocked' : 'contact-row--locked'}`}>
                  <div className="contact-row__left">
                    <span className="contact-row__platform">{c.label}</span>
                    {c.hint && unlocked && <span className="contact-row__hint">{c.hint}</span>}
                  </div>
                  <div className="contact-row__right">
                    {unlocked ? (
                      <a href={c.link} target={c.link.startsWith('http') ? '_blank' : '_self'} rel="noreferrer" className="contact-row__value contact-row__value--link">
                        {c.value}
                      </a>
                    ) : (
                      <div className="contact-row__locked">
                        <span className="contact-row__locked-val">{'•'.repeat(12)}</span>
                        <span className="contact-row__locked-tag">{c.minRank === 2 ? 'Premium+' : 'Platinum'}</span>
                      </div>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      ))}
    </div>
  )
}
